import { FC, ReactElement } from 'react'
import { generatePath, Navigate, useParams } from 'react-router-dom'

import { FeatureFlagName, useFeatureFlag } from 'modules/projects/hooks'
import { Routes } from 'routes/routes'
import { Loader, LoaderTypes } from 'ui/Loader'

interface FeatureFlagGuardProps {
  flag: FeatureFlagName
  children: ReactElement
}

/**
 * Раздел, закрытый фича-флагом проекта. SDD docs/SDD/platform/feature_flags/01_design.md.
 *
 * Пока проект грузится — показываем лоадер и НЕ редиректим: иначе вход по прямой
 * ссылке всегда выкидывал бы на дефолтный раздел.
 */
export const FeatureFlagGuard: FC<FeatureFlagGuardProps> = ({ flag, children }) => {
  const { isEnabled, isLoadingProject } = useFeatureFlag(flag)
  const { projectId } = useParams()

  if (isLoadingProject) {
    return <Loader type={LoaderTypes.SpinnerCenter} />
  }

  if (!isEnabled) {
    return <Navigate replace to={projectId ? generatePath(Routes.Forecast, { projectId }) : Routes.Main} />
  }

  return children
}
